import moment from 'moment'

export function encodeParams (params) {
  let body = ''
  for (let key in params) {
    if (body.length) {
      body += '&'
    }
    body += key + '='
    body += encodeURIComponent(params[key])
  }
  return body
}

export const dateFormatPrettify = 'LL'
export const dateFormatDefault = 'YYYY/MM/DD'
export const dateFormatTime = 'hh:mm:ss a'

export function dateToString (date, dateFormat = dateFormatPrettify) {
  return moment.utc(date).format(dateFormat)
}

export function stringToDate (text) {
  return moment.utc(text || moment().format())
}

export function dateTimeToString (text) {
  return `${dateToString(text)} ${dateToString(text, dateFormatTime)}`
}

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Get JSON string representation of the given map.
 *
 * @param map Map of event and corresponding handler method
 *
 * For example:
 * Input:
 * ```
 *  Map([
    ['loaded', null],
    ['rendered', function () { console.log('Rendered'); }]
  ]);
 * ```
 * Output:
 * ```
 * `[["loaded",""],["rendered","function () { console.log('Rendered'); }"]]`
 * ```
 */
export function stringifyMap (map) {
  // Return empty string for empty/null map
  if (!map) {
    return ''
  }

  // Get entries of map as array
  const mapEntries = Array.from(map)

  // Return JSON string
  return JSON.stringify(mapEntries.map((mapEntry) => {
  // Convert event handler method to a string containing its source code for comparison
    return [
      mapEntry[0],
      mapEntry[1] ? mapEntry[1].toString() : ''
    ]
  }))
};



// WEBPACK FOOTER //
// ./src/modules/Utils.js